import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { t } from '../common/LocalizationProvider'
import {
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    makeStyles,
    Tooltip,
    alpha
} from '@material-ui/core';
import {cyberStyles} from "../cssShared/cyberTheme";

const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
    list: {
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: 0,
        flexGrow: 1,
    },
    listItem: {
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(0.5),
        paddingLeft: theme.spacing(2),
        height: 48,
        justifyContent: 'flex-start',
        color: '#00f2ff !important',
        transition: 'all 0.2s',
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            color: theme.palette.primary.main,
            '& $icon': {
                color: theme.palette.primary.main,
            }
        },
    },
    icon: {
        minWidth: 40,
        color: 'rgb(51, 51, 102)',
        display: 'flex',
        justifyContent: 'center',
    },
    listItemCollapsed: {
        justifyContent: 'center',
        paddingLeft: 0,
        paddingRight: 0,
    }
}));

const ReportSidebar = ({ routes, hideDrawer, onCloseMobile }) => {
    const location = useLocation();
    const classes = useStyles();

    return (
        <List className={classes.list}>
            {routes.map((route, index) => {
                const isSelected = route.href === location.pathname;
                const ItemContent = (
                    <ListItem
                        button
                        component={Link}
                        to={route.href}
                        key={index}
                        selected={isSelected}
                        onClick={onCloseMobile}
                        classes={{
                            root: classes.listItem,
                            selected: classes.selected
                        }}
                        className={hideDrawer ? classes.listItemCollapsed : ''}
                    >
                        <ListItemIcon className={classes.icon}>
                            {route.icon}
                        </ListItemIcon>

                        {!hideDrawer && (
                            <ListItemText
                                primary={t(route.name)}
                                primaryTypographyProps={{ variant: 'body2', style: { fontWeight: isSelected ? 600 : 400 } }}
                            />
                        )}
                    </ListItem>
                );
                return hideDrawer ? (
                    <Tooltip title={t(route.name)} placement="right" arrow key={index}>
                        {ItemContent}
                    </Tooltip>
                ) : ItemContent;
            })}
        </List>
    )
}

export default ReportSidebar;